import Icon from '../components/Icon.vue'

Icon.register({"redo-alt":{"width":512,"height":512,"paths":[{"d":"M256.5 8C322.7 8.1 382.9 34.2 427.3 76.7L463 41C478.1 25.9 504 36.6 504 57.9V192C504 205.3 493.3 216 480 216H345.9C324.6 216 313.9 190.1 329 175L370.7 133.3C339.9 104.4 299.9 88.4 257.5 88 165.1 87.2 87.2 162 88 257.4 88.8 348 162.2 424 256 424 297.1 424 336 409.3 366.6 382.4 371.4 378.3 378.5 378.5 383 383L422.7 422.7C427.5 427.5 427.3 435.5 422.2 440.1 378.2 479.8 319.9 504 256 504 119 504 8 393 8 256 8 119.2 119.6 7.8 256.5 8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/redo-alt.js
// module id = null
// module chunks = 